import * as RadioGroup from '@radix-ui/react-radio-group';
import type { ReactNode } from 'react';
import { cn } from '@shared/lib/utils';

interface RadioOptionProps {
  selected: boolean;
  onSelect: () => void;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
}

export function RadioOption({
  selected,
  onSelect,
  label,
  icon,
  disabled = false,
}: RadioOptionProps) {
  const value = label.toLowerCase().replace(/\s+/g, '-');

  return (
    <RadioGroup.Root
      value={selected ? value : ''}
      onValueChange={onSelect}
      className="flex items-center"
    >
      <label
        className={cn(
          'flex items-center gap-2 text-sm text-text-primary',
          disabled && 'cursor-not-allowed opacity-50',
        )}
      >
        <RadioGroup.Item
          value={value}
          disabled={disabled}
          className={cn(
            'flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed',
            selected ? 'border-accent' : 'border-surface-3',
          )}
        >
          <RadioGroup.Indicator className="h-2 w-2 rounded-full bg-accent" />
        </RadioGroup.Item>
        {icon}
        <span>{label}</span>
      </label>
    </RadioGroup.Root>
  );
}
